import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBCard,
    MDBCardBody,
    MDBBadge,
    MDBBtn,
    MDBIcon,
    MDBSpinner,
    MDBTypography,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalBody,
    MDBModalFooter,
    MDBTooltip,
    MDBAlert,
    MDBModalTitle
} from 'mdb-react-ui-kit';
import moment from 'moment';
import { getClassBookingInfo, getGBussinessInfo } from '../services/memberApiServices';
import { idToSlug, slugToId } from '../utils/slug';
import unavailable from '../memberportal/assets/images/noavilable.png';
import trainerimg from '../memberportal/assets/images/coaching.png';
import Booksessions from '../memberportal/components/Booksessions';
import { getAllSubDomain, getClassDetails } from '../services/apiServices';
import copy from 'clipboard-copy';
import gymLogo from '../components/images/Easy-MembrLogo.png';
// ClassSlotSelector Component (enhanced with beautiful grid layout, scrolling, and collapsible sections)// ClassSlotSelector Component - Enhanced with compact grid and better spacing
const ClassSlotSelector = ({ slots, bookedSlots, handleSlotClick, classInfo, handleEventClick }) => {
    const [expandedDays, setExpandedDays] = useState({});

    const groupedSlots = slots.reduce((acc, slot) => {
        const dateKey = new Date(slot.startdate).toDateString();
        if (!acc[dateKey]) {
            acc[dateKey] = [];
        }
        acc[dateKey].push(slot);
        return acc;
    }, {});

    const sortedDates = Object.keys(groupedSlots).sort((a, b) =>
        new Date(a).getTime() - new Date(b).getTime()
    );

    const toggleDayExpand = (dateKey) => {
        setExpandedDays(prev => ({
            ...prev,
            [dateKey]: !prev[dateKey]
        }));
    };

    const getAvailabilityStatus = (slot) => {
        let booked = Number(slot.bookedslots) || 0;
        const availableSpots = slot.totalslots - booked;
        if (availableSpots === 0) return 'full';
        if (booked < 1) return 'available';
        return 'filling';
    };

    const getButtonColor = (status, isBooked) => {
        if (isBooked) return 'booked-slot';
        if (status === 'available') return 'aviail-Slots';
        if (status === 'filling') return 'filling-Slots';
        if (status === 'full') return 'full-Slots';
        return 'light';
    };

    // Responsive column sizes based on slot count
    const getColumnSize = (slotCount, index) => {
        // For single slot, make it full width on mobile, half on tablet, quarter on desktop
        if (slotCount === 1) return { xs: 12, sm: 6, md: 4, lg: 3 };
        // For 2 slots, make them side by side
        if (slotCount === 2) return { xs: 12, sm: 6, md: 4, lg: 3 };
        // For 3 slots, show in a row
        if (slotCount === 3) return { xs: 12, sm: 6, md: 4, lg: 3 };
        // For 4+ slots, show 4 per row on desktop
        return { xs: 12, sm: 6, md: 4, lg: 3 };
    };

    return (
        <div className="slot-selector-container">
            {sortedDates.map(dateKey => {
                const date = new Date(dateKey);
                const daySlots = groupedSlots[dateKey].sort((a, b) => new Date(a.startdate) - new Date(b.startdate));
                const isExpanded = expandedDays[dateKey] || false;
                const hasManySlots = daySlots.length > 4;

                // Show first 4 slots if not expanded, otherwise show all
                const visibleSlots = isExpanded ? daySlots : daySlots.slice(0, 4);
                const hiddenSlotsCount = daySlots.length - 4;

                const isToday = date.toDateString() === new Date().toDateString();
                const isTomorrow = date.toDateString() === new Date(Date.now() + 86400000).toDateString();
                const isWeekend = date.getDay() === 0 || date.getDay() === 6;

                let dateLabel = date.toLocaleDateString('en-US', {
                    weekday: 'short',
                    month: 'short',
                    day: 'numeric'
                });

                if (isToday) dateLabel = `Today, ${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
                if (isTomorrow) dateLabel = `Tomorrow, ${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;

                return (
                    <div className="date-group mb-4" key={dateKey}>
                        {/* Date Header */}
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center">
                                <div className={`date-indicator ${isWeekend ? 'weekend' : ''}`} style={{
                                    width: '4px',
                                    height: '24px',
                                    borderRadius: '2px',
                                    marginRight: '12px',
                                    background: isWeekend ? 'linear-gradient(135deg, #ff6b6b 0%, #ee5253 100%)' : '#b9bbc0ff',
                                }}></div>
                                <div className="d-flex align-items-center">
                                    <span className="fw-semibold" style={{
                                        fontSize: '1rem',
                                        color: isWeekend ? '#dc3545' : '#2d3748'
                                    }}>
                                        <MDBIcon far icon="calendar-alt" className="me-2" style={{ fontSize: '0.9rem' }} />
                                        {dateLabel}
                                    </span>
                                    <MDBBadge
                                        color="light"
                                        className="ms-3 rounded-pill px-2 py-1"
                                        style={{
                                            background: '#f0f4ff',
                                            color: '#4a5568',
                                            fontSize: '0.75rem',
                                            fontWeight: '500'
                                        }}
                                    >
                                        {daySlots.length} {daySlots.length === 1 ? 'session' : 'sessions'}
                                    </MDBBadge>
                                </div>
                            </div>

                            {/* Toggle button for days with many slots */}
                            {hasManySlots && (
                                <MDBBtn
                                    color="link"
                                    onClick={() => toggleDayExpand(dateKey)}
                                    className="p-0"
                                    style={{
                                        textDecoration: 'none',
                                        color: '#667eea',
                                        fontSize: '0.85rem',
                                        fontWeight: '500'
                                    }}
                                >
                                    <MDBIcon fas icon={isExpanded ? 'chevron-up' : 'chevron-down'} className="me-1" />
                                    {isExpanded ? 'Show less' : `+${hiddenSlotsCount} more`}
                                </MDBBtn>
                            )}
                        </div>

                        {/* Slots Grid - Compact and responsive */}
                        <MDBRow className="g-2">
                            {visibleSlots.map((slot, index) => {
                                console.log(slot)
                                const isBooked = bookedSlots.includes(slot._id);
                                const status = getAvailabilityStatus(slot);
                                const buttonColor = getButtonColor(status, isBooked);
                                const TrainerName = slot.trainerDetails?.firstname + " " + slot.trainerDetails?.lastname;
                                const isFutureEvent = new Date(slot.enddate) > new Date();
                                const hasAvailableSlots = (slot.totalslots - (Number(slot.bookedslots) || 0)) > 0;
                                const availableSpots = slot.totalslots - (Number(slot.bookedslots) || 0);
                                const colSize = getColumnSize(daySlots.length, index);

                                return (
                                    <MDBCol key={slot._id} {...colSize}>
                                        <div className="slot-card-wrapper position-relative">
                                            <MDBBtn
                                                color={buttonColor}
                                                className="w-100 slot-button"
                                                style={{
                                                    padding: '12px 8px',
                                                    borderRadius: '10px',
                                                    fontSize: '0.9rem',
                                                    background: isBooked ? '#e2e8f0' :
                                                        status === 'available' ? '#d4edda' :
                                                            status === 'filling' ? '#fff3cd' :
                                                                status === 'full' ? '#f8d7da' : '#fff',
                                                    border: isBooked ? '1px solid #cbd5e0' :
                                                        status === 'available' ? '1px solid #c3e6cb' :
                                                            status === 'filling' ? '1px solid #ffeeba' :
                                                                status === 'full' ? '1px solid #f5c6cb' : '1px solid #dee2e6',
                                                    color: isBooked ? '#718096' :
                                                        status === 'available' ? '#155724' :
                                                            status === 'filling' ? '#856404' :
                                                                status === 'full' ? '#721c24' : '#495057',
                                                    transition: 'all 0.2s ease',
                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                                }}
                                                onClick={() => handleSlotClick(slot, classInfo, TrainerName)}
                                                disabled={!isFutureEvent || !hasAvailableSlots || isBooked}
                                            >
                                                {/* Time Slot */}
                                                <div className="d-flex align-items-center justify-content-between mb-1">
                                                    <span className="fw-bold" style={{ fontSize: '0.95rem' }}>
                                                        <MDBIcon far icon="clock" className="me-1" style={{ fontSize: '0.8rem' }} />
                                                        {slot.timeslot}
                                                    </span>
                                                    {/* {hasAvailableSlots && (
                                                        <MDBBadge
                                                            color={availableSpots <= 2 ? 'warning' : 'success'}
                                                            pill
                                                            style={{ fontSize: '0.65rem', padding: '3px 6px' }}
                                                        >
                                                            {availableSpots} left
                                                        </MDBBadge>
                                                    )} */}
                                                </div>

                                                {/* Trainer Name - Truncated */}
                                                <div className="text-truncate mb-1" style={{ maxWidth: '100%' }}>
                                                    <MDBIcon fas icon="user" className="me-1" style={{ fontSize: '0.7rem' }} />
                                                    {TrainerName}
                                                </div>

                                                {/* Info Icon */}
                                                <MDBTooltip tag="span" title="View details" placement="top">
                                                    <MDBIcon
                                                        fas
                                                        icon="info-circle"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleEventClick(slot, classInfo, TrainerName);
                                                        }}
                                                        style={{
                                                            position: 'absolute',
                                                            top: '5px',
                                                            right: '5px',
                                                            fontSize: '0.8rem',
                                                            color: '#a0aec0',
                                                            cursor: 'pointer',
                                                            zIndex: 2
                                                        }}
                                                        className="hover-primary"
                                                    />
                                                </MDBTooltip>

                                                {/* Full Badge */}
                                                {!hasAvailableSlots && (
                                                    <MDBBadge
                                                        color="danger"
                                                        className="position-absolute top-0 end-0 m-1"
                                                        style={{ fontSize: '0.65rem', padding: '3px 6px' }}
                                                        pill
                                                    >
                                                        Full
                                                    </MDBBadge>
                                                )}
                                            </MDBBtn>
                                        </div>
                                    </MDBCol>
                                );
                            })}

                            {/* If there are hidden slots and not expanded, show placeholder */}
                            {!isExpanded && hasManySlots && (
                                <MDBCol xs={12} sm={6} md={4} lg={3}>
                                    <div
                                        className="d-flex align-items-center justify-content-center h-100"
                                        style={{
                                            padding: '12px 8px',
                                            background: '#f8f9fa',
                                            borderRadius: '10px',
                                            border: '1px dashed #dee2e6',
                                            color: '#6c757d',
                                            fontSize: '0.9rem',
                                            minHeight: '85px'
                                        }}
                                    >
                                        <MDBIcon fas icon="plus-circle" className="me-2" />
                                        <span>+{hiddenSlotsCount} more</span>
                                    </div>
                                </MDBCol>
                            )}
                        </MDBRow>
                    </div>
                );
            })}

            {slots.length === 0 && (
                <div className="text-center py-4">
                    <MDBIcon fas icon="calendar-times" size="2x" className="text-muted mb-2" />
                    <p className="text-muted mb-0">No available slots</p>
                </div>
            )}
        </div>
    );
};
// ClassListing Component (improved description toggle)
const ClassListing = ({ classInfo, slots, bookedSlots, handleSlotClick, handleEventClick, getAvailabilityStatus }) => {
    const [showFullDescription, setShowFullDescription] = useState(false);
    const cardRef = useRef(null);

    const truncateContent = (content, maxLength) => {
        if (content && (content.length > maxLength)) {
            return content.substring(0, maxLength) + '...';
        } else {
            return content;
        }
    };

    const stripHtmlTags = (html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    const handleToggleDescription = () => {
        setShowFullDescription(!showFullDescription);
    };

    const descriptionLength = classInfo?.description ? stripHtmlTags(classInfo.description).length : 0;
    const hasLongDescription = descriptionLength > 300;

    return (
        <>
            {/* Description Card */}
            <MDBCard className="mb-4 border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                <MDBCardBody className="p-4">
                    <div className="d-flex align-items-center mb-3">
                        <div className="icon-wrapper me-3" style={{
                            width: '40px',
                            height: '40px',
                        background: '#b9bbc0ff',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <MDBIcon fas icon="info-circle" className="text-white" />
                        </div>
                        <div>
                            <h5 className="mb-1" style={{ fontWeight: '600', color: '#2d3748' }}>About This Class</h5>
                            <p className="text-muted mb-0">Class description and details</p>
                        </div>
                    </div>

                    <div className="description-content px-2">
                        {classInfo?.description ? (
                            <>
                                <div
                                    className="description-text"
                                    style={{
                                        color: '#4a5568',
                                        lineHeight: '1.7',
                                        fontSize: '1rem',
                                        maxHeight: showFullDescription ? 'none' : '150px',
                                        overflow: 'hidden',
                                        position: 'relative',
                                        transition: 'max-height 0.3s ease'
                                    }}
                                >
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: showFullDescription
                                                ? classInfo.description
                                                : truncateContent(stripHtmlTags(classInfo.description), 300)
                                        }}
                                    />

                                    {!showFullDescription && hasLongDescription && (
                                        <div style={{
                                            position: 'absolute',
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            height: '50px',
                                            background: 'linear-gradient(transparent, white)'
                                        }} />
                                    )}
                                </div>

                                {hasLongDescription && (
                                    <MDBBtn
                                        color="link"
                                        className="p-0 mt-3"
                                        onClick={handleToggleDescription}
                                        style={{
                                            textDecoration: 'none',
                                            color: '#667eea',
                                            fontWeight: '500',
                                            fontSize: '0.95rem'
                                        }}
                                    >
                                        <MDBIcon fas icon={showFullDescription ? 'chevron-up' : 'chevron-down'} className="me-2" />
                                        {showFullDescription ? 'Show less' : 'Read full description'}
                                    </MDBBtn>
                                )}
                            </>
                        ) : (
                            <p className="text-muted fst-italic mb-0">No description available for this class.</p>
                        )}
                    </div>
                </MDBCardBody>
            </MDBCard>

            {/* Slots Card */}
            <MDBCard className="border-0 shadow-sm" style={{ borderRadius: '16px', overflow: 'hidden' }} ref={cardRef}>
                <MDBCardBody className="p-4">
                    <div className="d-flex align-items-center justify-content-between mb-4">
                        <div className="d-flex align-items-center">
                            <div className="icon-wrapper me-3" style={{
                                width: '40px',
                                height: '40px',
                        background: '#b9bbc0ff',
                                borderRadius: '10px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <MDBIcon fas icon="calendar-alt" className="text-white" />
                            </div>
                            <div>
                                <h5 className="mb-1" style={{ fontWeight: '600', color: '#2d3748' }}>Available Time Slots</h5>
                                <p className="text-muted mb-0">Select a time slot to book your class</p>
                            </div>
                        </div>
                        <MDBBadge color="primary" className="rounded-pill px-3 py-2" style={{ fontSize: '0.9rem' }}>
                            {slots.length} Upcoming Class{slots.length !== 1 ? 's' : ''}
                        </MDBBadge>
                    </div>

                    <ClassSlotSelector
                        slots={slots}
                        bookedSlots={bookedSlots}
                        handleSlotClick={handleSlotClick}
                        classInfo={classInfo}
                        handleEventClick={handleEventClick}
                        getAvailabilityStatus={getAvailabilityStatus}
                    />
                </MDBCardBody>
            </MDBCard>
        </>
    );
};
const ClassBookingPage = () => {
    const params = new URLSearchParams(window.location.search);
    const classid = params.get("cid");
    console.log(classid, 'class id from url');

    const classId = classid ? slugToId(classid) : null;
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [classInfo, setClassInfo] = useState(null);
    const [schedules, setSchedules] = useState([]);
    const [trainerData, setTrainerData] = useState([]);
    const [policyData, setPolicyData] = useState([]);
    const [plans, setPlans] = useState([]);
    const [bussinessinfo, setBusinessinfo] = useState(null);
    const [copyLink, setCopyLink] = useState(false);
    const [bookedSlots, setBookedSlots] = useState([]);

    // Modal states
    const [slotDetailsModal, setSlotDetailsModal] = useState(false);
    const [selectedSlot, setSelectedSlot] = useState(null);
    const [cancellationModal, setCancellationModal] = useState(false);
    const [policyinfo, setPolicyinfo] = useState([]);
    const [schedulModal, setSchedulModal] = useState(false);
    const [eventdata, setEventdata] = useState(null);

    // Booking states
    const [bookaClass, setBookaClass] = useState(false);
    const [selectedevent, setSelectedevent] = useState(null);
    const [enablebook, setEnablebook] = useState(false);
    const [invoiceCheck, setInvoiceCheck] = useState(false);

    const [Currentdomain, setCurrentdomain] = useState({})
    // Fetch class and schedule data
    useEffect(() => {
        const fetchClassData = async () => {
            setLoading(true);
            if (!classid) {
                setLoading(false);
                return;
            }
            try {
                const response = await getClassDetails(classId);
                if (!response || response === "false") {
                    setLoading(false);
                    return;
                }

                const tempData = await response.json();
                console.log(tempData, 'class details data');

                const targetClass = tempData?.classinfo;

                const today = new Date();
                today.setHours(0, 0, 0, 0);

                const classSchedules = (tempData?.scheduleinfo || [])
                    .filter(schedule => {
                        if (schedule.isprivate) return false;

                        const startDate = new Date(schedule.startdate);
                        const visibledaysbefore = parseInt(schedule?.visibledaysbefore || 0, 10);

                        const diffInMs = startDate - today;
                        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

                        return startDate >= today && Math.abs(diffInDays) <= visibledaysbefore;
                    })
                    .map(schedule => {
                        const trainer = tempData?.staffinfo?.find(t => t._id === schedule.trainerid);
                        return {
                            ...schedule,
                            trainerDetails: trainer
                        };
                    })
                    .sort((a, b) => new Date(a.startdate) - new Date(b.startdate));


                setBusinessinfo(tempData?.gymInfo || {});
                setClassInfo(targetClass);
                setSchedules(classSchedules);
                setTrainerData(tempData?.staffinfo || []);
                setPolicyData(tempData?.cancelationinfo || []);
            } catch (error) {
                console.error("Error fetching class data:", error);
            } finally {
                setLoading(false);
            }
        };

        if (classId) {
            fetchClassData();
        }
        if (!classid) {
            setLoading(false);
            return;
        }
    }, [classId]);

    const getAvailabilityStatus = (slot) => {
        const booked = Number(slot.bookedslots) || 0;
        const availableSpots = slot.totalslots - booked;
        if (availableSpots === 0) return 'full';
        if (booked < 1) return 'available';
        return 'filling';
    };
    function getMainDomain(hostname) {
        const parts = hostname.split('.');
        if (parts.length >= 2) {
            return parts.slice(-2).join('.');
        }
        return hostname;
    }
    useEffect(() => {
        if (bussinessinfo?._id) {
            fetchsubDomains()
        }
    }, [bussinessinfo])

    // Restore booking popup after login redirect
    useEffect(() => {
        if (!schedules.length || !classInfo) return;
        if (!localStorage.getItem("loggedMemberInfo") || !localStorage.getItem("memberinfo")) return;

        const pendingSlotId = sessionStorage.getItem("pendingSlotId");
        if (!pendingSlotId) return;

        const slot = schedules.find(s => s._id === pendingSlotId);
        sessionStorage.removeItem("pendingSlotId");
        if (!slot) return;

        const startMoment = moment(slot.timeslot, "hh:mm A");
        const duration = parseInt(classInfo.duration, 10) || 0;
        const endMoment = startMoment.clone().add(duration, 'minutes');
        const policy = policyData.find(p => p._id === slot.cancellationpolicyid) || {};

        const eventData = {
            price: classInfo.price || 0,
            trainer: slot.trainerDetails
                ? `${slot.trainerDetails.firstname} ${slot.trainerDetails.lastname}`
                : "Unknown Trainer",
            slotsBooked: slot.bookedslots || 0,
            slotsRemaining: slot.totalslots || classInfo.slots || 0,
            startTime: startMoment.format("hh:mm A"),
            endTime: endMoment.format("hh:mm A"),
            cancellationPolicy: policy?.cancelfee?.filter(fee => fee.checked) || [],
            description: classInfo.description,
            membershipdiscount: classInfo.membershipdiscount?.filter(d => d.checked) || [],
            scheduleinfo: slot,
            classInfo: classInfo,
            trainerInfo: slot.trainerDetails || {},
            category: classInfo.category || '',
            duration: duration
        };

        setSelectedevent(eventData);
        setEnablebook(true);
        setBookaClass(true);
    }, [schedules, classInfo, policyData]);

    async function fetchsubDomains() {
        const gymid = bussinessinfo?._id;

        const Domain = getMainDomain(window.location.hostname);
        const subDomainInfo = await getAllSubDomain(Domain);
        if (!subDomainInfo || subDomainInfo === "false") return;

        const subDomainData = await subDomainInfo.json();

        const matchedDomain = subDomainData?.length > 0 ? subDomainData.find((item) => item.gymid === gymid) : {};
        if (matchedDomain) {
            setCurrentdomain(matchedDomain);
        } else {
            setCurrentdomain({});
        }
    }
    // In ClassBookingPage.js - Update handleSlotClick function
    const handleSlotClick = (slot) => {
        // Check if user is logged in
        console.log(Currentdomain?.subdomain, 'current domain info');
        // const subdomain = Currentdomain?.subdomain;
        if (!localStorage.getItem("loggedMemberInfo") || !localStorage.getItem("memberinfo")) {
            const currentUrl = window.location.href;
            // let currentUrl = window.location.origin + "/class?cid=" + classid;

            // if (currentUrl.includes("portal.") && subdomain) {
            //     currentUrl = currentUrl.replace("portal", subdomain);
            // }

            sessionStorage.setItem("pendingRedirectUrl", currentUrl);
            sessionStorage.setItem("pendingSlotId", slot._id);

            navigate('/memberlogin', {
                state: {
                    path: `/class?cid=${classid}`,
                    waiverstatus: classInfo?.requireWaiver === true
                }
            });
            return;
        }

        // Prepare event data for booking
        const startMoment = moment(slot.timeslot, "hh:mm A");
        const duration = parseInt(classInfo.duration, 10) || 0;
        const endMoment = startMoment.clone().add(duration, 'minutes');
        const policy = policyData.find(p => p._id === slot.cancellationpolicyid) || {};

        const eventData = {
            id: slot._id,
            title: classInfo.name,
            start: new Date(slot.startdate),
            end: new Date(slot.enddate),
            extendedProps: {
                price: classInfo.price || 0,
                trainer: slot.trainerDetails ?
                    `${slot.trainerDetails.firstname} ${slot.trainerDetails.lastname}` :
                    "Unknown Trainer",
                slotsBooked: slot.bookedslots || 0,
                slotsRemaining: slot.totalslots || classInfo.slots || 0,
                startTime: startMoment.format("hh:mm A"),
                endTime: endMoment.format("hh:mm A"),
                cancellationPolicy: policy?.cancelfee?.filter(fee => fee.checked) || [],
                description: classInfo.description,
                membershipdiscount: classInfo.membershipdiscount?.filter(d => d.checked) || [],
                scheduleinfo: slot,
                classInfo: classInfo,
                trainerInfo: slot.trainerDetails || {},
                category: classInfo.category || '',
                duration: duration
            }
        };

        setSelectedevent(eventData.extendedProps);
        setEnablebook(true);
        setBookaClass(true);
    };
    const handleEventClick = (slot) => {
        const trainerName = slot.trainerDetails ?
            `${slot.trainerDetails.firstname} ${slot.trainerDetails.lastname}` :
            'Unknown Trainer';

        const eventData = {
            _id: slot._id,
            title: classInfo.name,
            startdate: slot.startdate,
            enddate: slot.enddate,
            timeslot: slot.timeslot,
            trainerDeatils: slot.trainerDetails,
            classInfo: classInfo,
            extendedProps: {
                price: classInfo.price,
                trainer: trainerName,
                slotsBooked: slot.bookedslots,
                slotsRemaining: slot.totalslots,
                description: classInfo.description,
                scheduleinfo: slot
            }
        };
        setEventdata(eventData);
        setSelectedSlot(eventData)
        setSchedulModal(true);
    };

    const handleBookFromDetails = () => {
        setSlotDetailsModal(false);

        if (!localStorage.getItem("loggedMemberInfo") || !localStorage.getItem("memberinfo")) {
            const currentUrl = window.location.href;
            // let currentUrl = window.location.origin + "/class?cid=" + classid;

            // const subdomain = Currentdomain?.subdomain;
            // if (currentUrl.includes("portal.") && subdomain) {
            //     currentUrl = currentUrl.replace("portal", subdomain);
            // }

            sessionStorage.setItem("pendingRedirectUrl", currentUrl);
            if (selectedSlot?._id) {
                sessionStorage.setItem("pendingSlotId", selectedSlot._id);
            }
            navigate('/memberlogin', {
                state: {
                    path: `/class?cid=${classid}`,
                    waiverstatus: classInfo?.requireWaiver === true
                }
            });
            return;
        }

        const startMoment = moment(selectedSlot?.timeslot, "hh:mm A");
        const duration = parseInt(classInfo.duration, 10) || 0;
        const endMoment = startMoment.clone().add(duration, 'minutes');
        const policy = policyData.find(p => p._id === selectedSlot.cancellationpolicyid) || {};

        const eventData = {
            id: selectedSlot._id,
            title: classInfo.name,
            start: new Date(selectedSlot.startdate),
            end: new Date(selectedSlot.enddate),
            extendedProps: {
                price: classInfo.price || 0,
                trainer: selectedSlot.trainerDetails ?
                    `${selectedSlot.trainerDetails.firstname} ${selectedSlot.trainerDetails.lastname}` :
                    "Unknown Trainer",
                slotsBooked: selectedSlot.bookedslots || 0,
                slotsRemaining: selectedSlot.totalslots || classInfo.slots || 0,
                startTime: startMoment.format("hh:mm A"),
                endTime: endMoment.format("hh:mm A"),
                cancellationPolicy: policy?.cancelfee?.filter(fee => fee.checked) || [],
                description: classInfo.description,
                membershipdiscount: classInfo.membershipdiscount?.filter(d => d.checked) || [],
                scheduleinfo: selectedSlot,
                classInfo: classInfo,
                trainerInfo: selectedSlot.trainerDetails || {},
                category: classInfo.category || '',
                duration: duration
            }
        };

        setSelectedevent(eventData.extendedProps);
        setEnablebook(true);
        setBookaClass(true);
    };

    const handleBookFromSchedule = () => {
        setSchedulModal(false);
        handleBookFromDetails();
    };

    const handleCallback = () => {
        setBookaClass(false);
        setInvoiceCheck(false);
    };

    const stripHtmlTags = (html) => {
        if (!html) return '';
        const doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    };

    const handlecopyClassUrl = () => {
        const shareUrl = window.location.href;
        copy(shareUrl);
        setCopyLink(true);
    };

    const handleShare = async () => {
        const shareUrl = window.location.href;
        const strippedDescription = stripHtmlTags(classInfo?.description || "");
        const truncatedDescription = strippedDescription.length > 100
            ? strippedDescription.substring(0, 100) + '...'
            : strippedDescription;

        try {
            if (navigator.share) {
                await navigator.share({
                    title: classInfo?.name || 'Class Booking',
                    text: [
                        `Join me for: ${classInfo?.name}`,
                        `Category: ${classInfo?.category || 'General'}`,
                        `Level: ${classInfo?.level || 'All Levels'}`,
                        `Duration: ${classInfo?.duration} minutes`,
                        `Price: ₹${classInfo?.price}`,
                        classInfo?.description && `Details: ${truncatedDescription}`
                    ].filter(Boolean).join('\n'),
                    url: shareUrl
                });
            }
        } catch (err) {
            console.log('Share failed:', err);
        }
    };

    const handlePolicyClick = (slot) => {
        const policy = policyData.find(p => p._id === slot.cancellationpolicyid) || {};
        const cancellationPolicy = policy?.cancelfee?.filter(fee => fee.checked) || [];

        setPolicyinfo({
            extendedProps: {
                cancellationPolicy: cancellationPolicy
            }
        });
        setCancellationModal(true);
    };

    const isFutureEvent = (event) => {
        if (!event) return false;
        const endDate = new Date(event.enddate || event.end);
        return new Date() < endDate;
    };

    const slotLimit = (event) => {
        if (!event) return 0;
        const booked = event.bookedslots || event.extendedProps?.slotsBooked || 0;
        const total = event.totalslots || event.extendedProps?.slotsRemaining || 0;
        return total - booked;
    };

    const getRecurrenceText = (slot) => {
        if (!slot) return '';

        const recurrence = slot?.recurrence || {};
        const recurrencetype = recurrence?.recurrencetype;

        const weekMap = ["1st", "2nd", "3rd", "4th", "5th"];
        const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        let recurrenceText = "";

        if (recurrencetype === "monthly") {
            let weeks = recurrence.value || [];
            let days = recurrence.subvalue || [];

            const allWeeks = weeks.includes(-1);
            const allDays = days.includes(-1);

            const weekText = allWeeks
                ? "every week"
                : weeks.map(i => weekMap[i - 1] || '').filter(Boolean).join(", ") + " week";

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if ((allWeeks || weeks.length) && (allDays || days.length)) {
                if (allWeeks) {
                    recurrenceText = `Every week on ${dayText}`;
                } else {
                    recurrenceText = `Every ${weekText} of the month on ${dayText}`;
                }
            }
        } else if (recurrencetype === "weekly") {
            let days = recurrence.value || [];

            const allDays = days.includes(-1);

            const dayText = allDays
                ? "all days"
                : days.map(i => dayMap[i] || '').filter(Boolean).join(", ");

            if (days.length || allDays) {
                recurrenceText = `Every week on ${dayText}`;
            }
        }

        return recurrenceText;
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
                <MDBSpinner role="status">
                    <span className="visually-hidden">Loading...</span>
                </MDBSpinner>
            </div>
        );
    }

    if (!classInfo) {
        return (
            <MDBContainer className="py-5">
                <MDBCard className="text-center shadow-3">
                    <MDBCardBody className="py-5">
                        <img src={unavailable} alt="Class not found" className="mb-4" style={{ opacity: 0.7, maxWidth: '120px' }} />
                        <MDBTypography tag="h4" className="mb-3">Class Not Found</MDBTypography>
                        <p className="text-muted mb-4">The class you're looking for doesn't exist or has been removed.</p>
                        <MDBBtn color="primary" size="lg" onClick={() => window.location.reload()}>
                            <MDBIcon fas icon="home" className="me-2" />
                            Refresh
                        </MDBBtn>
                    </MDBCardBody>
                </MDBCard>
            </MDBContainer>
        );
    }

    return (
        <>
            {!invoiceCheck &&

                <div className="class-booking-page" style={{ backgroundColor: '#f5f7fa', minHeight: '100vh' }}>
                    {/* Header */}
                    <div className="class-booking-header" style={{
                        background: '#9a9a9bff',
                        padding: '20px 0',
                        color: 'white',
                        marginBottom: '30px'
                    }}>
                        <MDBContainer>
                            <div className="text-center mt-3 d-flex justify-content-between align-items-center">
                                <div className="logo-header">
                                    <img
                                        src={bussinessinfo?.logourl || gymLogo}
                                        className='membergym-logo'
                                        alt="Gym Logo"
                                    // style={{ maxHeight: '50px' }}
                                    />
                                </div>
                                <div className="">
                                    <MDBTypography tag="h2" className="mb-2" style={{ fontWeight: 700 }}>
                                        {classInfo.name}
                                    </MDBTypography>
                                    <div className="d-flex justify-content-center gap-2">
                                        <MDBBadge color="light" className="px-3 py-2 rounded-pill text-dark">
                                            <MDBIcon fas icon="tag" className="me-1" />
                                            {classInfo.category}
                                        </MDBBadge>
                                        <MDBBadge
                                            color={
                                                classInfo.level === "Beginner" ? "success" :
                                                    classInfo.level === "Intermediate" ? "warning" :
                                                        classInfo.level === "Advanced" ? "danger" : "primary"
                                            }
                                            className="px-3 py-2 rounded-pill"
                                        >
                                            <MDBIcon fas icon="signal" className="me-1" />
                                            {classInfo.level}
                                        </MDBBadge>
                                    </div>
                                </div>
                                {/* <div className="d-flex gap-2"> */}
                                {/* <MDBTooltip tag="span" title="Copy link">
                                    <MDBIcon
                                        far
                                        icon="copy"
                                        style={{ cursor: 'pointer', fontSize: '1.2rem', color: 'white' }}
                                        onClick={handlecopyClassUrl}
                                    />
                                </MDBTooltip>
                                <MDBTooltip tag="span" title="Share">
                                    <MDBIcon
                                        fas
                                        icon="share-alt"
                                        style={{ cursor: 'pointer', fontSize: '1.2rem', color: 'white' }}
                                        onClick={handleShare}
                                    />
                                </MDBTooltip> */}
                                {/* </div> */}
                            </div>
                        </MDBContainer>
                    </div>

                    <MDBContainer className="pb-5">
                        {/* Class Info Cards */}
                        <MDBRow className="g-3 mb-4">
                            <MDBCol md={3} sm={6}>
                                <MDBCard className="shadow-2 border-0 h-100">
                                    <MDBCardBody className="text-center">
                                        <MDBIcon far icon="clock" size="2x" className="text-primary mb-2" />
                                        <h6 className="text-muted mb-1">Duration</h6>
                                        <h5 className="mb-0 fw-bold">{classInfo.duration} min</h5>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol md={3} sm={6}>
                                <MDBCard className="shadow-2 border-0 h-100">
                                    <MDBCardBody className="text-center">
                                        <MDBIcon fas icon="rupee-sign" size="2x" className="text-success mb-2" />
                                        <h6 className="text-muted mb-1">Price</h6>
                                        <h5 className="mb-0 fw-bold">₹{classInfo.price}</h5>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol md={3} sm={6}>
                                <MDBCard className="shadow-2 border-0 h-100">
                                    <MDBCardBody className="text-center">
                                        <MDBIcon fas icon="users" size="2x" className="text-info mb-2" />
                                        <h6 className="text-muted mb-1">Size</h6>
                                        <h5 className="mb-0 fw-bold">{classInfo.slots || 'N/A'} Spots</h5>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                            <MDBCol md={3} sm={6}>
                                <MDBCard className="shadow-2 border-0 h-100">
                                    <MDBCardBody className="text-center">
                                        <MDBIcon fas icon="calendar-alt" size="2x" className="text-warning mb-2" />
                                        <h6 className="text-muted mb-1">Sessions</h6>
                                        <h5 className="mb-0 fw-bold">{schedules.length} upcoming</h5>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                        </MDBRow>

                        {/* Class Listing */}
                        {schedules.length === 0 ? (
                            <MDBCard className="text-center py-5">
                                <MDBCardBody>
                                    <img src={unavailable} alt="No sessions" className="mb-3" style={{ opacity: 0.5, maxWidth: '100px' }} />
                                    <h5>No Upcoming Sessions</h5>
                                    <p className="text-muted">There are no scheduled sessions for this class at the moment.</p>
                                </MDBCardBody>
                            </MDBCard>
                        ) : (
                            <ClassListing
                                classInfo={classInfo}
                                slots={schedules}
                                bookedSlots={bookedSlots}
                                handleSlotClick={handleSlotClick}
                                handleEventClick={handleEventClick}
                                getAvailabilityStatus={getAvailabilityStatus}
                            />
                        )}
                    </MDBContainer>
                </div>
            }
            {/* Slot Details Modal */}
            <MDBModal open={slotDetailsModal} onClose={() => setSlotDetailsModal(false)} tabIndex='-1'>
                <MDBModalDialog size="lg">
                    <MDBModalContent style={{ maxHeight: '80%' }}>
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag="h5" className="mb-0">
                                    <MDBIcon fas icon="info-circle" className="me-2 text-primary" />
                                    {classInfo?.name}
                                </MDBTypography>
                                <div className="d-flex align-items-center">
                                    {selectedSlot && (
                                        <>
                                            <MDBTooltip tag="span" title="Cancellation Policy">
                                                <MDBIcon
                                                    fas
                                                    icon="file-alt"
                                                    className="me-3 text-primary cursor-pointer"
                                                    onClick={() => handlePolicyClick(selectedSlot)}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </MDBTooltip>
                                            <MDBTooltip tag="span" title="Copy link">
                                                <MDBIcon
                                                    far
                                                    icon="copy"
                                                    className="me-3 text-primary cursor-pointer"
                                                    onClick={handlecopyClassUrl}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </MDBTooltip>
                                            <MDBTooltip tag="span" title="Share">
                                                <MDBIcon
                                                    fas
                                                    icon="share-alt"
                                                    className="me-3 text-primary cursor-pointer"
                                                    onClick={handleShare}
                                                    style={{ cursor: 'pointer' }}
                                                />
                                            </MDBTooltip>
                                        </>
                                    )}
                                    <MDBBtn className='btn-close' color='none' onClick={() => setSlotDetailsModal(false)} />
                                </div>
                            </div>
                        </MDBModalHeader>

                        <MDBModalBody className="p-4">
                            {selectedSlot && (
                                <>
                                    <MDBRow className="g-3 ">
                                        <MDBCol md={4}>
                                            <div className="p-3 text-center" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                                                <MDBIcon far icon="calendar" className="text-primary mb-2" />
                                                <div><small className="text-muted">Date</small></div>
                                                <strong>{moment(selectedSlot.startdate).format('DD MMM YYYY')}</strong>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md={4}>
                                            <div className="p-3 text-center" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                                                <MDBIcon far icon="clock" className="text-primary mb-2" />
                                                <div><small className="text-muted">Time</small></div>
                                                <strong>{selectedSlot.timeslot}</strong>
                                            </div>
                                        </MDBCol>
                                        <MDBCol md={4}>
                                            <div className="p-3 text-center" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                                                <MDBIcon fas icon="users" className="text-primary mb-2" />
                                                <div><small className="text-muted">Available</small></div>
                                                <strong className={selectedSlot.totalslots - (selectedSlot.bookedslots || 0) === 0 ? 'text-danger' : 'text-success'}>
                                                    {selectedSlot.totalslots - (selectedSlot.bookedslots || 0)} / {selectedSlot.totalslots}
                                                </strong>
                                            </div>
                                        </MDBCol>
                                    </MDBRow>

                                    {selectedSlot.trainerDetails && (
                                        <div className="mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '10px' }}>
                                            <h6 className="mb-3">
                                                <MDBIcon fas icon="user-circle" className="me-2 text-primary" />
                                                Instructor
                                            </h6>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={selectedSlot.trainerDetails.imgUrl || trainerimg}
                                                    alt="Trainer"
                                                    style={{
                                                        width: '60px',
                                                        height: '60px',
                                                        borderRadius: '50%',
                                                        objectFit: 'cover',
                                                        marginRight: '15px'
                                                    }}
                                                />
                                                <div>
                                                    <h6 className="mb-1">
                                                        {selectedSlot.trainerDetails.firstname} {selectedSlot.trainerDetails.lastname}
                                                    </h6>
                                                    {selectedSlot.trainerDetails.email && (
                                                        <small className="text-muted d-block">
                                                            <MDBIcon far icon="envelope" className="me-2" />
                                                            {selectedSlot.trainerDetails.email}
                                                        </small>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {getRecurrenceText(selectedSlot) && (
                                        <div className="mb-3">
                                            <small className="text-muted">Recurrence</small>
                                            <p className="mb-0">
                                                <MDBIcon fas icon="sync-alt" className="me-2 text-primary" />
                                                {getRecurrenceText(selectedSlot)}
                                            </p>
                                        </div>
                                    )}

                                    {selectedSlot.location && (
                                        <div className="mb-3">
                                            <small className="text-muted">Location</small>
                                            <p className="mb-0">
                                                <MDBIcon fas icon="map-marker-alt" className="me-2 text-primary" />
                                                {selectedSlot.location}
                                            </p>
                                        </div>
                                    )}
                                </>
                            )}
                        </MDBModalBody>

                        <MDBModalFooter className="border-0 pt-0">
                            <MDBBtn color="secondary" onClick={() => setSlotDetailsModal(false)}>
                                Close
                            </MDBBtn>
                            {selectedSlot && (selectedSlot.totalslots - (selectedSlot.bookedslots || 0)) > 0 && (
                                <MDBBtn color="primary" onClick={handleBookFromDetails}>
                                    <MDBIcon fas icon="calendar-plus" className="me-2" />
                                    Book Now
                                </MDBBtn>
                            )}
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Schedule Details Modal */}
            <MDBModal open={schedulModal} onClose={() => setSchedulModal(false)} tabIndex='-1'>
                <MDBModalDialog size="lg">
                    <MDBModalContent style={{ maxHeight: '70%' }}>
                        <MDBModalHeader>
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <MDBTypography tag='h6' className="m-0 p-0">
                                    {eventdata?.title}
                                </MDBTypography>
                                <div className='d-flex align-items-center'>
                                    <MDBBtn className='btn-close' color='none' onClick={() => setSchedulModal(false)} />
                                </div>
                            </div>
                        </MDBModalHeader>
                        <MDBModalBody className='p-3 pt-4'>
                            <table className="table table-striped table-bordered mb-0">
                                <tbody>
                                    <tr>
                                        <td width="150px">Date</td>
                                        <td>{moment(eventdata?.startdate).format('dddd, MMMM DD, YYYY')}</td>
                                    </tr>
                                    <tr>
                                        <td>Time</td>
                                        <td>{eventdata?.timeslot}</td>
                                    </tr>
                                    <tr>
                                        <td>Host</td>
                                        <td>{eventdata?.trainerDeatils ?
                                            `${eventdata.trainerDeatils.firstname} ${eventdata.trainerDeatils.lastname}` :
                                            "Unknown Trainer"}</td>
                                    </tr>
                                    <tr>
                                        <td>Price</td>
                                        <td>₹{eventdata?.extendedProps?.price} /-</td>
                                    </tr>
                                    <tr>
                                        <td>Available Slots</td>
                                        <td className={slotLimit(eventdata) === 0 ? "text-danger" : "text-success"}>
                                            {slotLimit(eventdata)} slots available
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Description</td>
                                        <td>
                                            <p className='mb-0'
                                                dangerouslySetInnerHTML={{
                                                    __html: eventdata?.extendedProps?.description || "--"
                                                }}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </MDBModalBody>
                        <MDBModalFooter className="px-3 pb-2">
                            <MDBBtn color='secondary' onClick={() => setSchedulModal(false)}>
                                Close
                            </MDBBtn>
                            {isFutureEvent(eventdata) && slotLimit(eventdata) > 0 && (
                                <MDBBtn color='primary' onClick={handleBookFromSchedule}>
                                    Book Now
                                </MDBBtn>
                            )}
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Cancellation Policy Modal */}
            <MDBModal tabIndex='-1' open={cancellationModal} onClose={() => setCancellationModal(false)}>
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                <MDBIcon fas icon="file-invoice" className="me-2 text-primary" />
                                Cancellation Policy
                            </MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => setCancellationModal(false)} />
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p className="mb-3 text-muted">
                                If you cancel your booking before the class starts, a cancellation fee will be applied based on the number of days remaining.
                            </p>
                            <table className="table table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th>Cancellation Period</th>
                                        <th>Cancellation Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {policyinfo?.extendedProps?.cancellationPolicy?.length > 0 ? (
                                        policyinfo.extendedProps.cancellationPolicy.map((element, idx) => (
                                            <tr key={idx}>
                                                <td>{element.days} day(s) before</td>
                                                <td className="text-danger fw-bold">{element.feevalue}% Fee</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="2" className="text-center">Non Refundable</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={() => setCancellationModal(false)}>
                                Close
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* Booking Modal */}
            {enablebook && (
                <Booksessions
                    invoiceCheck={invoiceCheck}
                    handleCallback={handleCallback}
                    bookaClass={bookaClass}
                    setbookaClass={setBookaClass}
                    togglebookaClass={() => setBookaClass(!bookaClass)}
                    bussinessinfo={bussinessinfo}
                    selectedevent={selectedevent}
                    setInvoiceCheck={setInvoiceCheck}
                />
            )}

            {/* Alert Modals */}
            <MDBAlert
                color='success'
                autohide
                position='top-right'
                delay={2000}
                appendToBody
                open={copyLink}
                onClose={() => setCopyLink(false)}
            >
                <MDBIcon fas icon="check-circle" className="me-2" />
                Link copied to clipboard!
            </MDBAlert>
        </>
    );
};

export default ClassBookingPage;